import React, { FunctionComponent } from 'react';

import { getAvailableExtras } from 'scenes/motor/helpers/OptionalExtras/getAvailableExtras';
import {
  getIncludedExtras,
  getSelectedExtras,
  getSelectedInsuranceType,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { OptionalExtrasStep as CommonOptionalExtrasStep } from 'scenes/common/components/Steps';
import analytics from 'scenes/motor/analytics';
import { getApiData } from 'scenes/common/helpers/apiData';

const OptionalExtrasStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  referenceData,
  onUpdateToPolicyDetails,
  onUpdateOptionalExtras,
  onClickSaveQuoteModal,
}) => (
  <CommonOptionalExtrasStep
    defaultStateValue={getSelectedExtras(funnelState)}
    availableExtras={getAvailableExtras(getSelectedInsuranceType(funnelState))}
    includedExtras={getIncludedExtras(funnelState)}
    quoteDetails={funnelState.apiResponses.quoteDetails}
    onNext={() => {
      analytics().optionalExtras(funnelState, getApiData(referenceData));
      onUpdateToPolicyDetails();
    }}
    onUpdateOptionalExtras={onUpdateOptionalExtras}
    onClickFindOutMore={() => analytics().findOutMore(funnelState)}
    onClickSaveQuoteModal={onClickSaveQuoteModal}
  />
);

export default OptionalExtrasStep;
